import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../features/user/userSlice";
import Footer from "../components/Footer/Footer";
import { renderTextWithNormalDash } from "../utils/textFormatters";
import { Helmet } from "react-helmet";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo, loading, error } = useSelector((state) => state.userLogin);

  useEffect(() => {
    if (userInfo) {
      navigate("/admin/insight");
    }
  }, [userInfo, navigate]);

  const submitHandler = (e) => {
    e.preventDefault();
    dispatch(login({ email, password }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  }
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f7f7f7",
        }}
      >
        <form
          onSubmit={submitHandler}
          style={{
            backgroundColor: "#fff",
            padding: "2.5rem",
            borderRadius: "12px",
            width: "100%",
            maxWidth: "400px",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <h2 style={{ textAlign: "center", marginBottom: "1.5rem" }}>Admin Login</h2>

          {error && (
            <p style={{ color: "red", textAlign: "center", marginBottom: "1rem" }}>
              {renderTextWithNormalDash(error)}
            </p>
          )}

          <div style={{ marginBottom: "1rem" }}>
            <label htmlFor="email" style={{ display: "block", marginBottom: "0.5rem" }}>
              Email Address
            </label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "8px",
                fontFamily: "arial"
              }}
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label htmlFor="password" style={{ display: "block", marginBottom: "0.5rem" }}>
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: "100%",
                padding: "0.75rem",
                border: "1px solid #ccc",
                borderRadius: "8px",
              }}
            />
            <button
              type="button"
              onClick={togglePasswordVisibility}
              style={{
                marginTop: "0.5rem",
                backgroundColor: "#ddd",
                border: "none",
                borderRadius: "8px",
                padding: "0.5rem",
                cursor: "pointer",
              }}
            >
              {showPassword ? "Hide" : "Show"} Password
            </button>
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: "100%",
              backgroundColor: "#222",
              color: "#fff",
              padding: "0.75rem",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default AdminLogin;
